(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/input-ssn.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/input-ssn.js'); 'use strict';

svs.player_login.behaviors.InputSsn = Marionette.Behavior.extend({
  ui: {
    ssnInput: '.js-ssn-input',
    loginButton: '.js-bankid-login',
    backButton: '.js-back-to-bankid',
    rememberMe: '.js-remember-me'
  },
  events: {
    'click @ui.loginButton': 'onLoginClick',
    'paste @ui.ssnInput': 'onSsnPaste',
    'keyup @ui.ssnInput': 'onSsnKeyup',
    'click @ui.ssnInput': 'onSsnClick'
  },
  dashRegexp: /([0-9]{8})(?!-)/,
  prependTwentyRegexp: /^0/,
  prependNineteenRegexp: /^[3-9]{1,1}|^(?!19|20)[0-9]{2,2}|^190|^(?!200)[2-9][0-9]{2,2}/,
  doubleEndingDashRegexp: /--$/,

  onAttach() {
    this.ui.ssnInput.focus();

    if (this.view.model.get('ssn')) {
      this.ui.ssnInput.val(this.prependDigits(this.view.model.get('ssn')));
    }

    if (this.view.model.get('rememberChecked')) {
      this.ui.rememberMe.prop('checked', true);
    }
  },

  onSsnPaste(e) {
    let ssn;

    if (e.originalEvent.clipboardData) {
      ssn = e.originalEvent.clipboardData.getData('text');
    } else {
      ssn = window.clipboardData.getData('text');
    }

    e.preventDefault();
    ssn = ssn && ssn.trim();

    if (/[0-9-]/g.test(ssn) && ssn.length < 14) {
      this.ui.ssnInput.val(this.prependDigits(ssn));
    }
  },

  onSsnKeyup(event) {
    const keyCode = event.charCode || event.keyCode;
    const value = this.ui.ssnInput.val();
    let ssn; 

    if (keyCode !== 8 && keyCode !== 46) {
      if (value.length === 12) {
        ssn = value.replace(/-/g, '');

        if (!isNaN(parseInt(ssn, 10)) && value.indexOf('-') > -1) {
          this.ui.ssnInput.val(value + this.checkSumCalc(ssn));
        }
      } else if (value.length < 4 || value.length === 8) {
        this.ui.ssnInput.val(this.prependDigits(value));
      } else if (value.length === 10 && event.key === '-') {
        this.ui.ssnInput.val(value.replace(this.doubleEndingDashRegexp, '-'));
      }
    }
  },

  onSsnClick() {
    const value = this.ui.ssnInput.val();
    const newValue = this.prependDigits(value);

    if (value.length !== newValue.length) {
      this.ui.ssnInput.val(newValue);
      this.ui.ssnInput.prop('selectionStart', newValue.length).prop('selectionEnd', newValue.length);
    }
  },

  onLoginClick(e) {
    const personalNumber = this.ui.ssnInput.val();
    const personalNumberParam = personalNumber.replace(/-/g, '');
    Boolean(e) && e.preventDefault();

    if (this.ui.rememberMe.prop('checked')) {
      svs.components.Storage.browser.set('ssn', 'customer_login', personalNumber, svs.components.Storage.constants.EXPIRES_1YEAR);
      svs.components.Storage.browser.set('rememberMe', 'customer_login', true);
    } else {
      svs.components.Storage.browser.remove('ssn', 'customer_login');
      svs.components.Storage.browser.remove('rememberMe', 'customer_login');
    }

    if (svs.components.formValidation.validateRequiredFields(['ssn']) && svs.components.formValidation.validateFields(['ssn'])) {
      this.view.model.set({
        ssn: personalNumberParam
      }, {
        silent: true
      });
      this.view.triggerMethod('block:navigation');
      this.view.triggerMethod('ssn:submit');
    }
  },

  prependDigits(number) {
    if (number) {
      number = number.trim();

      if (number.match(this.prependTwentyRegexp)) {
        number = "20".concat(number);
      } else if (number.match(this.prependNineteenRegexp)) {
        number = "19".concat(number);
      }

      if (number.length >= 8) {
        number = number.replace(this.dashRegexp, '$1-');
      }
    }

    return number;
  },

  checkSumCalc(number) {
    let sum = 0;
    let i;
    const delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
    number = number.substring(2);

    for (i = 0; i < number.length; i++) {
      sum += parseInt(number.charAt(i), 10);
    }

    for (i = number.length - 1; i >= 0; i -= 2) {
      sum += delta[parseInt(number.charAt(i), 10)];
    }

    if (10 - sum % 10 === 10) {
      return 0;
    }

    return 10 - sum % 10;
  }

});
 })(window);